import { View } from '../UNSAFE_View';
import { styles } from './themes/TabBarMixedSeparator.css';

import type { Size } from '../utils/UNSAFE_size';

type TabBarMixedSeparatorProps = {
  /**
   * Padding around the visual Separator line.
   */
  padding?: Size;
};

/**
 * TabBarMixedSeparator is a component that renders a visual separator (displayed
 * as a vertical line) between collections of tabs within TabBarMixed.
 *
 * @param {TabBarMixedSeparatorProps} props Component props for TabBarMixedSeparator.
 * @returns {JSX.Element} Component element for TabBarMixedSeparator.
 */
export function TabBarMixedSeparator(props: TabBarMixedSeparatorProps) {
  const { padding = 0 } = props;

  return (
    <View padding={[0, padding, 0, padding]}>
      <div class={styles.separator} role="presentation" />
    </View>
  );
}
